// 
export const RATEQUOTE_LIST = 'RATEQUOTE_LIST';
export const RATEQUOTE_PAGINATION = 'RATEQUOTE_PAGINATION';
export const RATEQUOTE_SUMMARY = 'RATEQUOTE_SUMMARY';